module.exports = __webpack_public_path__ + "static/media/ic_fire.734e017a.png";